import useStableCallback from './useStableCallback'

export const useDownloadFileCallback = () => {
  const downloadFile = useStableCallback(({ url, fileName }: { url: string; fileName: string }) => {
    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(url)
  })
  return { downloadFile }
}
